import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(value: any, func: (item: any) => any): any {
    return value.filter(item => func(item));
  }
}
